import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { Link } from "react-router-dom"
//Import Images
import avatar1 from "../../assets/images/users/avatar-1.jpg"
import PropTypes from 'prop-types';

function CardUser(props) {
  //Get Name abreviations
  let obj = JSON.parse(localStorage.getItem("authMildUser"));
  let name=(obj.staffname);
  let initials = name.split(' ').reduce((acc, subname) => acc + subname[0], '')
 
  //Setting Menu
  const toggleSettings = () => {
    setSettingsMenu(settingsMenu)
  }

  return (
    <React.Fragment>
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <Row>
                <Col lg="4">
                  <div className="d-flex">
                    
                      <div className="me-3">
                        <div className="avatar-md mx-auto mt-1">
                            <span className={ "avatar-title rounded-circle bg-soft bg-primary primary text-primary font-size-24"} >
                              {initials}
                            </span>
                        </div>
                      </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5 className="mb-1">{props.username}</h5>
                        <p className="mb-0">{props.role}</p>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col lg="8" className="align-self-center">
                  <div className="text-lg-center mt-4 mt-lg-0">
                    <Row>
                      <Col xs="4">
                        <Link to="/approvals">
                        <div>
                          <p className="text-dark text-truncate mb-2">
                            Pending Approvals
                          </p>
                          <h5 className="mb-0 text-danger">{props.pendingApprovals}</h5>
                        </div>
                        </Link>
                      </Col>
                      <Col xs="4">
                      <Link to="/approve-fullterm-appraisals-list">
                        <div>
                          <p className="text-dark text-truncate mb-2">
                            Pending Appraiser Ratings
                          </p>
                          <h5 className="mb-0 text-dark">{props.pendingAppraisals}</h5>
                        </div>
                        </Link>
                      </Col>
                      <Col xs="4">
                        <Link to="/leave-requests">
                        <div>
                          <p className="text-dark text-truncate mb-2">
                            Your Leave Requests
                          </p>
                          <h5 className="mb-0 text-dark">{props.yourLRequests}</h5>
                        </div>
                        </Link>
                      </Col>
                     
                     
                      
                    </Row>
                  </div>
                </Col>

  
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}
CardUser.propTypes = {
  username: PropTypes.any,
  role: PropTypes.any,
  pendingApprovals:PropTypes.any,
  yourLPlans: PropTypes.any,
  yourLRequests: PropTypes.any,
  pendingAppraisals: PropTypes.any,
  initials: PropTypes.any
};
export default CardUser
